// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'calendar-range';

export const Component = () => (
  <path d='M23.562 2.92h-4.828V1.468c0-.327-.14-.468-.469-.468-.328 0-.469.14-.469.468V2.92H7.203V1.468c0-.327-.14-.468-.469-.468-.328 0-.469.14-.469.468V2.92H1.437a.927.927 0 0 0-.656.282.925.925 0 0 0-.281.655v19.206c0 .234.094.469.281.656a.927.927 0 0 0 .656.281h22.126a.927.927 0 0 0 .656-.281.925.925 0 0 0 .281-.656V3.857a.925.925 0 0 0-.281-.655.927.927 0 0 0-.656-.282h-.001Zm0 5.763v14.38H1.437V8.684h22.125Zm0-4.825v3.841H1.437V3.858h22.125ZM14.89 11.54v1.92h-1.922v-1.92h1.922Zm4.828 0v1.92h-1.922v-1.92h1.922ZM7.202 16.365v1.92H5.281v-1.92h1.921Zm4.828 0v1.92h-1.92v-1.92h1.921Z' />
);

export const viewBox = '0 0 25 25';
